import {
  HirerPromoCodesBannerConnectedCart,
  type TrackingEvent,
} from '@seek/hirer-promo-codes-banner';
import { useLanguage } from '@vocab/react';
import { useCallback } from 'react';
import { useLocation } from 'react-router';

import {
  ROUTE_CLASSIFY,
  ROUTE_MANAGE,
  ROUTE_SELECT_AD_TYPE,
  ROUTE_WRITE,
} from 'src/app/shared/constants/routes';
import {
  PROMO_CODE_BANNER_KEY,
  SHOPPING_CART_SUBSCRIPTION_RESPONSE_KEY,
} from 'src/app/shared/constants/shoppingCart';
import {
  GetAdProductsForAdPostingDocument,
  type GetAdProductsForAdPostingQueryVariables,
} from 'src/graphql/generated';

export const PromoCodeBannerConnectedCart = ({
  draftId,
  onTrackingCallback,
}: {
  draftId?: string;
  onTrackingCallback: (eventData: TrackingEvent) => void;
}) => {
  const { language } = useLanguage();
  const { pathname } = useLocation();

  const shouldRender =
    [ROUTE_CLASSIFY, ROUTE_SELECT_AD_TYPE, ROUTE_WRITE, ROUTE_MANAGE].includes(
      pathname,
    ) && draftId;

  const getProductIdsDocumentConstructVariables = useCallback(
    (productSetId: string) => {
      const input: GetAdProductsForAdPostingQueryVariables = {
        input: { productSetId, locale: language },
        draftId,
      };
      return input;
    },
    [draftId, language],
  );

  return (
    shouldRender && (
      <HirerPromoCodesBannerConnectedCart
        onTrackingCallback={onTrackingCallback}
        shoppingCart={{
          key: PROMO_CODE_BANNER_KEY,
          getProductIdsDocument: GetAdProductsForAdPostingDocument,
          getProductIdsDocumentConstructVariables,
          subscriptionResponseKey: SHOPPING_CART_SUBSCRIPTION_RESPONSE_KEY,
        }}
      />
    )
  );
};
